import { balanceResult } from '../../utils/types';
import { tokenAxios } from '../index';

export const requestBalance = async (tokenIds: string[]) => {
  const result = await tokenAxios.post<balanceResult>('/balance', { tokenIds });
  return result.data;
};
